(function () {
	const initGallerySliders = () => {
		const galleries = Array.from(
			document.querySelectorAll('.metafield-gallery__slider')
		);
		if (galleries.length === 0) return;

		galleries.forEach((gallery) => {
			const sectionId = gallery.dataset.id;
			const perRow = parseFloat(gallery.dataset.perRow) || 3;
			const mobilePerRow = parseFloat(gallery.dataset.mobile) || 1;
			const speed = (parseFloat(gallery.dataset.speed) || 5) * 1000;
			const autoplay = gallery.dataset.autoplay === 'true';
			const loop = gallery.dataset.loop === 'true';
			const stopAutoplay = gallery.dataset.stopAutoplay === 'true';
			const showArrows = gallery.dataset.arrows === 'true';
			const showDots = gallery.dataset.dots === 'true';
			const spacing = parseFloat(gallery.dataset.spacing) || 0;

			let autoplayConfig = {};
			if (autoplay) {
				autoplayConfig = {
					autoplay: {
						delay: speed,
						disableOnInteraction: false,
					},
				};
			}

			const swiperEl = gallery.querySelector('.swiper');
			if (!swiperEl) return;

			const swiperInstance = new Swiper(swiperEl, {
				loop: loop,
				slidesPerView: mobilePerRow,
				spaceBetween: spacing,
				speed: 600,
				longSwipesRatio: 0.1,
				allowTouchMove: true,
				breakpoints: {
					750: {
						slidesPerView: Math.min(perRow, Math.max(2, mobilePerRow)),
						spaceBetween: spacing,
					},
					990: {
						slidesPerView: perRow,
						spaceBetween: spacing,
					},
				},
				...(showArrows && {
					navigation: {
						nextEl: gallery.querySelector('.metafield-gallery__nav-btn--next'),
						prevEl: gallery.querySelector('.metafield-gallery__nav-btn--prev'),
					},
				}),
				...(showDots && {
					pagination: {
						el: gallery.querySelector('.metafield-gallery__pagination'),
						clickable: true,
					},
				}),
				...autoplayConfig,
			});

			if (autoplay && stopAutoplay) {
				gallery.addEventListener('mouseenter', function () {
					swiperInstance.autoplay.stop();
				});
				gallery.addEventListener('mouseleave', function () {
					swiperInstance.autoplay.start();
				});
			}
		});
	};

	document.addEventListener('DOMContentLoaded', function () {
		initGallerySliders();
		document.addEventListener('shopify:section:load', function () {
			initGallerySliders();
		});
	});
})();
